import React, { MouseEvent, useState } from 'react';

// Material ui
import {
    Grid,
    IconButton
} from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Icons
import { Close, Attachment } from '@/assets/icons';

// Variables
import VARIABLES from '@/assets/variables';

// Styles
import '../Inputs.scss';

interface Props {
    value: File | null,
    onChange: (value: React.SetStateAction<File | null>) => void,
    disabled?: boolean,
    label?: string,
    placeholder?: string,
    className?: string;
    name?: string,
    id?: string,
    optional?: boolean,
    variant?: string,
    maxSize?: number | string,
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}

const FileInput: React.FC<Props> = ({
    value,
    variant = 'primary',
    onChange,
    placeholder,
    className = '',
    label,
    disabled = false,
    optional = false,
    name,
    id,
    maxSize = 25000000,
    md,
    lg,
    sm,
    xs
}) => {
    const [ { errorMsg, inputError }, setError ] = useState({
        errorMsg: '',
        inputError: false
    });

    // useEffect(() => {
    //     if (optional) return;
    //     if (!optional && !value)
    //         setError({
    //             inputError: true,
    //             errorMsg: 'Este campo es requerido'
    //         });
    //     else setError({
    //         inputError: false,
    //         errorMsg: ''
    //     });
    // }, [value]);

    const validateInput = (inputValue: File | null) => {
        if (!optional && !inputValue)
            setError({
                inputError: true,
                errorMsg: 'Este campo es requerido'
            });
        else if (!inputValue) return setError({
            inputError: false,
            errorMsg: ''
        });
        else if (maxSize && inputValue.size > Number(maxSize))
            setError({
                inputError: true,
                errorMsg: 'El archivo es demasiado grande'
            });
        else setError({
            inputError: false,
            errorMsg: ''
        });
    };

    return (
        <Grid
            className={`ui-FileInput ${className}`}
            item
            id={id}
            md={md}
            lg={lg}
            sm={sm}
            xs={xs === 1 ? undefined : xs}
            style={{
                width: xs === 1 ? '6rem' : ''
            }}
        >
            {label && (
                <Typography
                    className="ui-Input-label"
                    variant="input-head"
                    color={disabled ? 'content-light' : 'primary-dark'}
                >
                    {`${label}${optional ? ' (opcional)' : ''}` || (
                        <span>&nbsp;</span>
                    )}
                </Typography>
            )}
            <label
                className={`ui-FileInput-container ${variant}${errorMsg ? ' error-border' : ''}`}
                style={{
                    cursor: disabled ? 'auto' : 'pointer'
                }}
            >
                <input
                    type="file"
                    name={name}
                    style={{ display: 'none' }}
                    onChange={({ target }) => {
                        if (target.files) {
                            validateInput(target.files[0]);
                            onChange(target.files[0]);
                        }
                    }}
                    disabled={disabled}
                />
                <Typography
                    className="ui-FileInput-text"
                    variant="body-regular"
                    color={value ? 'primary-dark' : 'content'}
                >
                    {!value ? placeholder : value.name}
                </Typography>
                { value ? (
                    <IconButton
                        className="ui-Input-adornment"
                        onClick={(e: MouseEvent) => {
                            e.preventDefault();
                            validateInput(null);
                            onChange(null);
                        }}
                        disabled={disabled}
                    >
                        <Close
                            color={disabled ? VARIABLES.palette.content_light : VARIABLES.palette.secondary_color}
                        />
                    </IconButton>
                ) : (
                    <Attachment
                        className="ui-Input-adornment"
                        color={disabled ? VARIABLES.palette.content_light : VARIABLES.palette.secondary_color}
                    />
                )}
            </label>
            { inputError && (
                <Typography
                    variant="note-regular"
                    color="error"
                    className="ui-Error-msg"
                >
                    {errorMsg}
                </Typography>
            )}
        </Grid>
    );
};

export default FileInput;
